import { MOAInterface } from '@submodules/MOA/interfaces/moa.interface';
import { Injectable } from '@angular/core';
import { AppConfig } from '@app/app.config';

@Injectable()
export class MoaConfig extends AppConfig {
    /**
     * Получить данные по DocumentServer МОП
     */
    public settingsMOA: MOAInterface;

    /**
     * URL YII2
     */
    public urlYii: string;

    constructor() {
        super();
    }

    // Переопределяем метод обработки данных из родительского метода
    protected processConfigData(data: any): void {
        super.processConfigData(data);

        this.settingsMOA = data.document_server_moa_settings ?? {};
        this.urlYii = data.server_yii_url ?? '';
    }
}
